import { Box, Stack, UnstyledButton, Text } from '@mantine/core';
import { IconEye, IconEyeOff } from '@tabler/icons';

export interface ChildFilterItem {
  id: string;
  label: string;
  active: boolean;
  filterCount: number;
}

export interface ChildFiltersDropdownManageFiltersProps {
  searchInput: React.ReactNode;
  childFilters: ChildFilterItem[];
  middlePanelSearch: string;
  handleChildFilterSelect: (childFilterId: string) => void;
  parentId: string;
  filterVisibility: Record<string, boolean>;
  onToggleVisibility: (filterId: string) => void;
}

const ChildFiltersDropdownManageFilters: React.FC<ChildFiltersDropdownManageFiltersProps> = ({
  searchInput,
  childFilters,
  middlePanelSearch,
  handleChildFilterSelect,
  parentId,
  filterVisibility,
  onToggleVisibility,
}) => (
  <Box
    pl="md"
    pr={0}
    pb="md"
    pt="xs"
    mt="xs"
    sx={{
      borderRadius: 8,
    }}
  >
    {/* {searchInput} */}
    <Stack spacing="xs">
      {childFilters
        .filter(
          (child) =>
            !middlePanelSearch ||
            child.label.toLowerCase().includes(middlePanelSearch.toLowerCase())
        )
        .sort((a, b) => {
          const keyA = `${parentId}.${a.id}`;
          const keyB = `${parentId}.${b.id}`;
          const rank = (key: string) => (filterVisibility[key] === false ? 1 : 0);
          const d = rank(keyA) - rank(keyB);
          if (d !== 0) return d;
          return a.label.localeCompare(b.label);
        })
        .map((childFilter) => {
          const visibilityKey = `${parentId}.${childFilter.id}`;
          return (
            <UnstyledButton
              key={childFilter.id}
              onClick={() => handleChildFilterSelect(childFilter.id)}
              className="filter-category-button filter-child-button"
              style={{ justifyContent: 'space-between' }}
            >
              <Text className="ellipsis-text" title={childFilter.label}>
                {childFilter.label}
              </Text>
              <Box
                component="span"
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation();
                  onToggleVisibility(visibilityKey);
                }}
                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: 8 }}
              >
                {filterVisibility[visibilityKey] !== false ? (
                  <IconEye size={16} color="#9ca3af" stroke={1.5} />
                ) : (
                  <IconEyeOff size={16} color="#9ca3af" stroke={1.5} />
                )}
              </Box>
            </UnstyledButton>
          );
        })}
    </Stack>
  </Box>
);

export default ChildFiltersDropdownManageFilters;